import { Radio as HeroUiRadio } from '@heroui/react';
import { type FC, memo } from 'react';

type RadioProps = {
    children: React.ReactNode;
    value: string;
    isDisabled?: boolean;
    className?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export const Radio: FC<RadioProps> = memo(({ children, className, ...rest }) => (
    <HeroUiRadio
        {...rest}
        classNames={{
            base: className,
            labelWrapper: 'font-normal text-4',
        }}
    >
        {children}
    </HeroUiRadio>
));
